module.exports = __webpack_public_path__ + "static/media/Artboard11.52ffe4e6.png";